import { createContext, useContext, useState, useEffect } from 'react';
import { fetchContactPageData } from './pageDataService';

const ContactDataContext = createContext(null);

export const ContactDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_contact_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchContactPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_contact_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache contact data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ContactDataContext.Provider value={{ data, isLoading }}>
      {children}
    </ContactDataContext.Provider>
  );
};

export const useContactData = () => {
  const context = useContext(ContactDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
